import gql from 'graphql-tag';

const QUERY_LANDINGS = gql`
  query Landings($slug: String, $locale: String = "en") {
    allCities {
      id
      currencyIsoCode
    }
    seoLanding(slug: $slug, locale: $locale) {
      cityId
      seoMetaTitle
      seoMetaDescription
      modules {
        type
        config
      }
      routing
    }
  }
`;

const getSEOLandingsQuery = client => (slug, locale) =>
  client.query({
    query: QUERY_LANDINGS,
    variables: { slug, locale },
    fetchPolicy: 'network-only'
  });

export default getSEOLandingsQuery;
